var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.544922,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88889 10.4021L13.3179 14.3554L13.3197 14.3569C13.9225 14.7832 14.2241 14.9964 14.5545 15.0788C14.8464 15.1516 15.1533 15.1516 15.4453 15.0788C15.7759 14.9964 16.0784 14.7825 16.6823 14.3554C16.6823 14.3554 20.1645 11.7786 22.1111 10.4021M7 18.8022V12.2879C7 11.3279 7 10.8475 7.19377 10.4807C7.36421 10.1582 7.63598 9.89612 7.97049 9.73177C8.35077 9.54492 8.84897 9.54492 9.84462 9.54492H20.1557C21.1514 9.54492 21.6485 9.54492 22.0288 9.73177C22.3633 9.89612 22.636 10.1582 22.8064 10.4807C23 10.8471 23 11.3269 23 12.2851V18.8051C23 19.7633 23 20.2425 22.8064 20.6088C22.636 20.9314 22.3633 21.1939 22.0288 21.3583C21.6489 21.5449 21.152 21.5449 20.1583 21.5449H9.8417C8.84799 21.5449 8.3504 21.5449 7.97049 21.3583C7.63598 21.1939 7.36421 20.9314 7.19377 20.6088C7 20.2421 7 19.7623 7 18.8022Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.edbbe2805cff37b77ce11a1815d98a13.svg";
export { ForwardRef as ReactComponent };